/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/login/login.js
*    TO   --> ./legacy-web/src/main/assets/js/login/login.js
**/

//Initialize sandbox
AAcom('utilities', 'ajax', function (AAUI) {

    const _busyFormSubmit = AAUI.getProperty('busyProcessing');
    var _closeButton = AAUI.getProperty('closeButton');

    AAUI.util = new aa_Utilities();
    AAUI.loginDialog = function(dialogId) {
        var self = {};
        self.openDialog = $j('#' + dialogId + 'Wrapper').data('opendialog') || false;
        self.open = function(openDialog) {
            if(openDialog) {
                AAUI.util.aaDialog('' + dialogId).openDialog();
            }
            return openDialog;
        };
        self.init = function(size) {
            var buttons = [{name: _closeButton, cssClass: 'btn'}];
            AAUI.util.aaDialog('' + dialogId, {
                width: size || 'medium',
                buttons: buttons,
                toggleScroll: true
            });
        };
        return self;
    };

    AAUI.changeSubmitAction = function() {
        var self = {};
        self.init = function(loginId, submitAction) {
            AAUI.onClick(loginId, function(e) {
                e.preventDefault();
                self.submitForm(submitAction);
            });
        };
        self.submitForm = function(submitAction) {
            var loginForm = $j('#loginFormId');
            loginForm.attr('action', submitAction);
            loginForm.submit();
        };
        return self;
    }();

    AAUI.initPageSubmit = function() {
        AAUI.onSubmit('#loginFormId', function() {
            if ($j('body').aaBusy({
                message: _busyFormSubmit
            }).start());
        });
    };

    AAUI.initPage = function(pageLoad) {
        pageLoad = pageLoad || false;
        if (pageLoad) {
            AAUI.initPageSubmit();
            AAUI.changeSubmitAction.init('#button_login_guest', '/loyalty/login/continue');
            var loginMainErrorMsg = AAUI.loginDialog('loginMainErrorMsg');
                loginMainErrorMsg.init('small');
                loginMainErrorMsg.open(loginMainErrorMsg.openDialog);
            var unableToAuthenticateErrorMsg = AAUI.loginDialog('unableToAuthenticateErrorMsg');
                unableToAuthenticateErrorMsg.init('small');
                unableToAuthenticateErrorMsg.open(unableToAuthenticateErrorMsg.openDialog);
        }
    };

    $j(document).ready(function() {
        AAUI.initPage(true);
    });
});